(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const saveData = Boolean(navigator.connection && navigator.connection.saveData);

  const initPortfolioFilters = (root = document) => {
    root.querySelectorAll('[data-drx-work-index]').forEach((index) => {
      if (index.dataset.drxReady === 'true') return;
      index.dataset.drxReady = 'true';
      const buttons = [...index.querySelectorAll('[data-drx-work-filter]')];
      const items = [...index.querySelectorAll('[data-drx-work-item]')];
      buttons.forEach((button) => button.addEventListener('click', () => {
        const key = button.dataset.drxWorkFilter;
        buttons.forEach((candidate) => {
          const selected = candidate === button;
          candidate.classList.toggle('is-active', selected);
          candidate.setAttribute('aria-pressed', String(selected));
        });
        items.forEach((item) => {
          const services = (item.dataset.drxWorkItem || '').split(',');
          item.hidden = key !== 'all' && !services.includes(key);
        });
      }));
    });
  };

  const initMenus = (root = document) => {
    root.querySelectorAll('.drx-shell-menu').forEach((menu) => {
      menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => menu.removeAttribute('open')));
    });
  };

  const mountCrown = (stage) => {
    if (stage.dataset.drxMounted === 'true') return;
    const modelUrl = stage.dataset.modelUrl;
    if (!modelUrl || saveData) return;
    stage.dataset.drxMounted = 'true';
    const createViewer = () => {
      const viewer = document.createElement('model-viewer');
      viewer.src = modelUrl;
      viewer.alt = 'Dracarrj crown in three dimensions';
      viewer.setAttribute('camera-controls', '');
      viewer.setAttribute('interaction-prompt', 'none');
      viewer.setAttribute('loading', 'lazy');
      viewer.setAttribute('reveal', 'auto');
      if (!reducedMotion.matches) viewer.setAttribute('auto-rotate', '');
      stage.replaceChildren(viewer);
      if ('IntersectionObserver' in window) {
        const visibilityObserver = new IntersectionObserver((entries) => {
          const visible = entries.some((entry) => entry.isIntersecting);
          if (!reducedMotion.matches && visible) viewer.setAttribute('auto-rotate', '');
          else viewer.removeAttribute('auto-rotate');
        });
        visibilityObserver.observe(viewer);
      }
    };
    if (customElements.get('model-viewer')) {
      createViewer();
      return;
    }
    if (!window.drxModelViewerLoader) {
      window.drxModelViewerLoader = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.type = 'module';
        script.src = 'https://ajax.googleapis.com/ajax/libs/model-viewer/4.1.0/model-viewer.min.js';
        script.addEventListener('load', resolve, { once: true });
        script.addEventListener('error', reject, { once: true });
        document.head.appendChild(script);
      });
    }
    window.drxModelViewerLoader.then(createViewer).catch(() => {
      stage.dataset.drxMounted = 'false';
    });
  };

  const initCrown = (root = document) => {
    root.querySelectorAll('[data-drx-crown-stage]').forEach((stage) => {
      if (stage.dataset.drxCrownReady === 'true') return;
      stage.dataset.drxCrownReady = 'true';
      if (!('IntersectionObserver' in window)) return mountCrown(stage);
      const observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          mountCrown(stage);
          observer.disconnect();
        }
      }, { rootMargin: '300px 0px' });
      observer.observe(stage);
    });
  };

  const pauseHiddenVideo = () => {
    if (!document.hidden) return;
    document.querySelectorAll('video').forEach((video) => video.pause());
  };

  const initVideoVisibility = (root = document) => {
    if (!('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) entry.target.pause();
      });
    }, { rootMargin: '120px 0px' });
    root.querySelectorAll('video').forEach((video) => {
      if (video.dataset.drxVisibilityReady === 'true') return;
      video.dataset.drxVisibilityReady = 'true';
      observer.observe(video);
    });
  };

  const init = (root = document) => {
    initPortfolioFilters(root);
    initMenus(root);
    initCrown(root);
    initVideoVisibility(root);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('visibilitychange', pauseHiddenVideo);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
